import { useCallback, useState } from 'react';

const useAddEditModalControls = <TEntity extends unknown>() => {
  const [entityToEdit, setEntityToEdit] = useState<TEntity | null>(null);
  const [isAddEditModalVisible, setModalVisible] = useState<boolean>(false);

  const showModalForAdd = useCallback(() => {
    setEntityToEdit(null);
    setModalVisible(true);
  }, [setEntityToEdit]);

  const showModalForEdit = useCallback((entityToEdit: TEntity) => {
    setEntityToEdit(entityToEdit);
    setModalVisible(true);
  }, [setEntityToEdit]);

  const hideModalForAddEdit = useCallback(() => {
    setEntityToEdit(null);
    setModalVisible(false);
  }, [setEntityToEdit]);

  return {
    entityToEdit,
    showModalForEdit,
    showModalForAdd,
    hideModalForAddEdit,
    isAddEditModalVisible,
  };
};

export default useAddEditModalControls;
